
export const state = {
    user: {},
    currentStory: {}
}

export const profile = {
    profile: {
        displayName: '',
        email: '',
        emailVerified: true,
        isAnonymous: false,
        uid: '',
    },
    settings: {
        appBarBackground: '',
        favoriteFont: '',
        storyPaper: '',
        "Primary Background": '#282c34',
        "Secondary Background": 'white'
    }
}

export const modals = {
    login: false,
    changeDisplayName: false,
    changeEmail: false,
    changePassword: false,
    deleteAccount: false,
    sendVerificationEmail: false,
    terms: false
}